import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getDatepickerConfig } from '@app/app.helper';
import { CommonSharedModule } from 'common/common.module';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { AnswerCheckboxComponent } from './answer-checkbox/answer-checkbox.component';
import { AnswerDateTimeComponent } from './answer-datetime/answer-datetime.component';
import { AnswerNumericTextboxComponent } from './answer-numeric-textbox/answer-numeric-textbox.component';
import { AnswerRadioComponent } from './answer-radio/answer-radio.component';
import { AnswerSelectComponent } from './answer-select/answer-select.component';
import { AnswerTextareaComponent } from './answer-textarea/answer-textarea.component';
import { AnswerTextboxComponent } from './answer-textbox/answer-textbox.component';
import { AnswerToggleComponent } from './answer-toggle/answer-toggle.component';
import { AnswerTypeFieldComponent } from './answer-type-field/answer-type-field.component';
import { AnswerTypeComponent } from './answer-type.component';
import { AnswerMultiSelectComponent } from './answer-multi-select/answer-multi-select.component';
import { ClientEvideFormService } from '../services/client-evide-form.service';
import { AnswerSelectWithTextComponent } from './answer-select-with-text/answer-select-with-text.component';
import { FieldTitleModule } from 'shared/field-title/field-title.module';


@NgModule({
  declarations: [
    AnswerTypeComponent,
    AnswerTextboxComponent,
    AnswerTextareaComponent,
    AnswerMultiSelectComponent,
    AnswerNumericTextboxComponent,
    AnswerSelectComponent,
    AnswerSelectWithTextComponent,
    AnswerRadioComponent,
    AnswerCheckboxComponent,
    AnswerToggleComponent,
    AnswerDateTimeComponent,
    AnswerTypeFieldComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    CommonSharedModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    NgSelectModule,
    FieldTitleModule
  ],
  exports: [AnswerTypeFieldComponent],
  providers: [{ provide: BsDatepickerConfig, useFactory: getDatepickerConfig }, ClientEvideFormService]
})
export class AnswerTypeModule { }
